/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";

export interface IStateOSDProps {
    image?: string;
    textColor?: string;
    titleNormalText?: string;
    titleBoldText?: string;
    description?: string;
    buttonText?: string;
    onButtonClick?(): void;
}

export const StateOSD = ({
    image,
    titleNormalText,
    textColor,
    titleBoldText,
    description,
    buttonText,
    onButtonClick
}: IStateOSDProps) => {
    const _renderImageIf = () => {
        if (image) {
            return <Image src={image} className="img-fluid w-75" />;
        }
    };
    const _renderTitleIf = () => {
        if (titleNormalText) {
            return (
                <h3 style={{ color: textColor ? textColor : "whitesmoke" }} className="mt-5">
                    {`${titleNormalText} `}{" "}
                    {titleBoldText && (
                        <span className="fw-bolder">{titleBoldText}</span>
                    )}
                </h3>
            );
        }
    };
    const _renderDescriptionIf = () => {
        if (description) {
            return <p style={{ color: textColor ? textColor : "whitesmoke" }} className="lead my-4">{description}</p>;
        }
    };
    const _renderButtonIf = () => {
        if (buttonText) {
            return (
                <Button
                    variant={"primary"}
                    className="d-inline-flex align-items-center justify-content-center mb-4"
                    onClick={onButtonClick}
                >
                    {buttonText}
                </Button>
            );
        }
    };
    return (
        <>
            <Container>
                <Row>
                    <Col
                        xs={12}
                        className="text-center d-flex align-items-center justify-content-center"
                    >
                        <div>
                            {_renderImageIf()}
                            {_renderTitleIf()}
                            {_renderDescriptionIf()}
                            {_renderButtonIf()}
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

StateOSD.defaultProps = {};
